'use client';

import { useLocale } from 'next-intl';
import { useSearchParams } from 'next/navigation';

import { usePathname } from 'i18n/routing';
import { getWindow } from 'utils/isBrowser';

const useGetPathToNavigate = () => {
  const locale = useLocale();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const getPathWithQueryParams = ({ destinationPath = pathname, search = null, useCurrentParams = true }) => {
    const searchParamsString = search || (useCurrentParams ? searchParams.toString() : '');
    const path = `${destinationPath}${searchParamsString ? `?${searchParamsString}` : ''}`;

    // Preserve the hash if it exists (only on client-side)
    const hash = getWindow()?.location.hash || '';
    const finalPath = hash ? `${path}${hash}` : path;

    return finalPath;
  }
  return {
    path: pathname,
    locale,
    isTranslationsEnabled: true,
    isFtLoading: false,
    getPathWithLocale: path => path,
    getPathWithQueryParams,
  };
};

export default useGetPathToNavigate;
